(() => {
  const configNode = document.querySelector('[data-store-copy]');
  if (!configNode) return;
  const copy = JSON.parse(configNode.textContent);
  const rootPath = document.documentElement.dataset.rootUrl || '/';
  const root = rootPath.endsWith('/') ? rootPath : rootPath + '/';
  const dialog = document.getElementById('StoreCart');
  const surfaces = [...document.querySelectorAll('[data-cart-surface]')];
  let busy = false;
  let currentCart = JSON.parse(document.querySelector('[data-initial-cart]').textContent);
  let returnFocus;
  const format = (cents, currency = copy.currency) => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency, currencyDisplay: 'narrowSymbol' }).format(cents / 100) + ' ' + currency;
  const status = (message = '', error = false) => {
    document.querySelectorAll('[data-cart-status]').forEach(node => {
      node.textContent = message;
      node.classList.toggle('is-error', error);
    });
  };
  const node = (tag, className, text) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text !== undefined) element.textContent = text;
    return element;
  };
  const request = async (url, options = {}) => {
    let response;
    let result;
    try {
      response = await fetch(root + url, { credentials: 'same-origin', cache: 'no-store', ...options });
      result = await response.json();
    } catch { throw new Error(copy.error); }
    if (!response.ok) throw new Error(result.description || result.message || copy.error);
    return result;
  };
  const lock = value => {
    busy = value;
    surfaces.forEach(surface => {
      surface.setAttribute('aria-busy', String(value));
      surface.querySelectorAll('input,button').forEach(element => { element.disabled = value; });
      surface.querySelectorAll('[data-cart-remove]').forEach(element => { element.setAttribute('aria-disabled', String(value)); });
    });
  };
  const render = cart => {
    currentCart = cart;
    document.querySelectorAll('[data-cart-count]').forEach(element => { element.textContent = cart.item_count; });
    document.querySelectorAll('[data-cart-open]').forEach(element => { element.setAttribute('aria-label', copy.cartLabel.replace('__COUNT__', cart.item_count)); });
    surfaces.forEach(surface => {
      const items = surface.querySelector('[data-cart-items]');
      items.replaceChildren();
      surface.querySelector('[data-cart-empty]').hidden = cart.item_count > 0;
      surface.querySelector('[data-cart-form]').hidden = cart.item_count === 0;
      surface.querySelector('[data-cart-total]').textContent = format(cart.total_price, cart.currency);
      cart.items.forEach((item, index) => {
        const row = node('article', 'cart-line');
        const picture = node('a', 'cart-line-image');
        picture.href = item.url;
        if (item.image) {
          const image = node('img');
          const thumbnail = new URL(item.image, location.origin);
          thumbnail.searchParams.set('width', '180');
          image.src = thumbnail.href;
          image.alt = item.product_title;
          image.width = 84;
          image.height = 96;
          image.loading = 'eager';
          picture.append(image);
        }
        const info = node('div', 'cart-line-info');
        const title = node('a', 'cart-line-title', item.product_title);
        title.href = item.url;
        info.append(title);
        if (item.variant_title && item.variant_title !== 'Default Title') info.append(node('p', '', item.variant_title));
        info.append(node('strong', '', format(item.final_line_price, cart.currency)));
        const controls = node('div', 'cart-line-actions');
        const label = node('label', '', copy.quantity);
        const input = node('input');
        input.id = surface.dataset.cartContext + '-quantity-' + index;
        input.type = 'number';
        input.name = 'updates[]';
        input.min = '0';
        input.step = '1';
        input.inputMode = 'numeric';
        input.value = item.quantity;
        input.dataset.cartLine = item.key;
        input.setAttribute('aria-label', copy.quantity + ': ' + item.product_title);
        label.htmlFor = input.id;
        label.append(input);
        const remove = node('a', 'text-button', copy.remove);
        remove.href = root + 'cart/change?id=' + encodeURIComponent(item.key) + '&quantity=0';
        remove.dataset.cartRemove = item.key;
        remove.setAttribute('aria-label', copy.remove + ': ' + item.product_title);
        controls.append(label, remove);
        info.append(controls);
        row.append(picture, info);
        items.append(row);
      });
    });
  };
  const refresh = async () => { const cart = await request('cart.js', { headers: { Accept: 'application/json' } }); render(cart); return cart; };
  const openCart = async trigger => {
    if (!dialog) return;
    returnFocus = trigger || document.activeElement;
    if (!dialog.open) dialog.showModal();
    document.body.classList.add('cart-is-open');
    dialog.querySelector('[data-cart-close]').focus();
    if (!busy) {
      lock(true);
      try { await refresh(); } catch (error) { status(error.message || copy.error, true); }
      finally { lock(false); }
    }
  };
  document.querySelectorAll('[data-cart-open]').forEach(trigger => trigger.addEventListener('click', event => {
    if (!dialog) return;
    event.preventDefault();
    status();
    openCart(trigger);
  }));
  document.querySelectorAll('[data-cart-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
  dialog?.addEventListener('close', () => {
    document.body.classList.remove('cart-is-open');
    if (returnFocus?.isConnected) returnFocus.focus();
  });
  dialog?.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const box = dialog.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
  });
  const changeLine = async (key, quantity, source, message) => {
    if (busy) return;
    lock(true);
    status(copy.loading);
    const surface = source.closest('[data-cart-surface]');
    const index = [...surface.querySelectorAll('[data-cart-line]')].findIndex(input => input.dataset.cartLine === key);
    try {
      const cart = await request('cart/change.js', { method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
      render(cart);
      status(message);
      document.querySelectorAll('[data-product-status]').forEach(element => { element.textContent = ''; });
      const next = surface.querySelectorAll('[data-cart-line]')[Math.max(0, Math.min(index, cart.items.length - 1))];
      if (next) next.focus();
      else if (dialog?.open) dialog.querySelector('[data-cart-close]').focus();
    } catch (error) {
      if (currentCart) render(currentCart);
      status(error.message || copy.error, true);
    } finally { lock(false); }
  };
  document.addEventListener('change', event => {
    const input = event.target.closest('[data-cart-line]');
    if (!input) return;
    const quantity = Number(input.value);
    if (!Number.isInteger(quantity) || quantity < 0 || !input.reportValidity()) return;
    changeLine(input.dataset.cartLine, quantity, input, quantity === 0 ? copy.removed : copy.updated);
  });
  document.addEventListener('click', event => {
    const remove = event.target.closest('[data-cart-remove]');
    if (!remove) return;
    event.preventDefault();
    if (!busy) changeLine(remove.dataset.cartRemove, 0, remove, copy.removed);
  });
  document.querySelectorAll('[data-cart-form]').forEach(form => form.addEventListener('submit', event => { if (busy) event.preventDefault(); }));
  document.querySelectorAll('[data-product-root]').forEach(product => {
    const form = product.querySelector('[data-store-product-form]');
    if (!form) return;
    const variants = JSON.parse(product.querySelector('[data-product-variants]').textContent);
    const variantInput = form.querySelector('[name=id]');
    const add = form.querySelector('[data-product-add]');
    const buy = form.querySelector('[data-buy-now]');
    const pageStatus = form.querySelector('[data-product-status]');
    const mainImage = product.querySelector('[data-product-image]');
    const zoom = product.querySelector('[data-product-zoom]');
    const thumbs = [...product.querySelectorAll('[data-product-thumb]')];
    let adding = false;
    const showImage = (src, full, alt) => {
      if (!mainImage) return;
      mainImage.removeAttribute('srcset');
      mainImage.src = src;
      mainImage.alt = alt || copy.imageAlt;
      zoom.href = full || src;
      thumbs.forEach(thumb => { thumb.setAttribute('aria-pressed', String(thumb.dataset.image === src)); });
    };
    thumbs.forEach(thumb => thumb.addEventListener('click', () => showImage(thumb.dataset.image, thumb.dataset.imageFull, thumb.dataset.imageAlt)));
    const availability = () => {
      const variant = variants.find(item => String(item.id) === variantInput.value);
      const available = Boolean(variant?.available);
      add.disabled = adding || !available;
      buy.disabled = adding || !available;
      add.textContent = adding ? copy.adding : available ? copy.add : copy.soldOut;
      buy.textContent = copy.buy;
      product.querySelector('[data-product-availability]').textContent = available ? copy.available : copy.soldOut;
      if (variant) product.querySelector('[data-product-price]').textContent = format(variant.price);
      return variant;
    };
    variantInput.addEventListener('change', () => {
      const variant = availability();
      pageStatus.textContent = '';
      if (!variant) return;
      const url = new URL(location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
      if (variant.featured_image?.src) {
        const imageUrl = new URL(variant.featured_image.src, location.origin);
        imageUrl.searchParams.set('width', '1400');
        showImage(imageUrl.href, variant.featured_image.src, product.querySelector('h1').textContent);
      }
    });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (adding || busy || !form.reportValidity()) return;
      const variant = availability();
      const quantity = Number(form.querySelector('[name=quantity]').value);
      if (!variant?.available || !Number.isInteger(quantity) || quantity < 1) return;
      const goToCheckout = event.submitter?.hasAttribute('data-buy-now');
      adding = true;
      form.setAttribute('aria-busy', 'true');
      availability();
      pageStatus.classList.remove('is-error');
      pageStatus.textContent = copy.adding;
      lock(true);
      try {
        await request('cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ items: typeof window.pdpOffersItems === 'function' ? window.pdpOffersItems(form, variant, quantity) : [{ id: variant.id, quantity }] }) });
        if (goToCheckout) { location.assign(root + 'checkout'); return; }
        await refresh();
        pageStatus.textContent = copy.added;
        status(copy.added);
        await openCart(add);
      } catch (error) {
        pageStatus.textContent = error.message || copy.error;
        pageStatus.classList.add('is-error');
      } finally { adding = false; form.setAttribute('aria-busy', 'false'); lock(false); availability(); }
    });
    availability();
    product.querySelectorAll('.product-description img').forEach(image => {
      if (!image.alt) image.alt = copy.imageAlt;
      if (!image.loading) image.loading = 'lazy';
    });
  });
  document.querySelector('[data-sort-select]')?.addEventListener('change', event => event.target.form.requestSubmit());
})();
